export enum WARNING_THEMES {
  DEFAULT = `default`,
  ERROR = `error`,
  ERROR_DARK = `error-dark`,
  SENSITIVE = `sensitive`,
  NO_ICON = `no-icon`,
}
